import React, { Component } from 'react';
import { Grid,  Button, Divider,Tab,  Table} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { PtDateInput, PtInputConditionTab, PtSelect} from '../grit-utilities';
import '../index.css';
import $ from 'jquery';
import config from '../config.json';


export default class DateManager extends Component{

    constructor(props) {
        super(props);
        this.state = {
            activeIndex:0,
            disable: true,
            edit: false,
            editBtnDisable: false,
            zoneName: "",
            zonedesc: [],
            pavedStartDate: null,
            pavedEndDate: null,
            unpavedStartDate:null,
            unpavedEndDate: null,
            options: [],
            selectedZone:0,
            countyZones:[]

       }
        const header = {
            fontWeight: "bold",
            fonstSize: "1em"
        }
        const addzone = {
            marginTop: '15px'
        }
        
        const calender = {
            marginLeft: '20px'
        }
        
        this.panes = [
            {
                menuItem: 'Date Manager', render: () =>
                    <Tab.Pane>
                        
                        <PtSelect label="Select Zone" options={this.state.options} onChange={this.onChangeDropdown} disabled={this.state.disable}
                        defaultVal={this.state.selectedZone} name="selectedZone" />
                        
                        <Table compact="very">
                             <Table.Body>
                                    <Table.Row>
                                        <Table.Cell  style={header}>PAVED ROADS</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell  ><div style={calender}>Start Date</div></Table.Cell>
                                        <Table.Cell  >End Date</Table.Cell>
                                    </Table.Row>                                    
                                <Table.Row>

                                <Table.Cell><div style={calender}>
                                    <PtDateInput disabled={this.state.disable} name="pavedStartDate" placeholder="Start Date" 
                                            value={this.state.pavedStartDate==null ? '':this.state.pavedStartDate} onChange={(date) => { this.onChangeDate(date, "pavedStartDate"); }} />
                                    </div>      
                                </Table.Cell>
                                <Table.Cell ><PtDateInput disabled={this.state.disable}  name="pavedEndDate" placeholder="End Date" 
                                                    value={this.state.pavedEndDate==null ? '':this.state.pavedEndDate}
                                    onChange={(date) => { this.onChangeDate(date, "pavedEndDate"); }} /></Table.Cell>
                                
                            </Table.Row>
                                    <Table.Row>
                                        <Table.Cell style={header}>UNPAVED ROADS</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell  ><div style={calender}>Start Date</div></Table.Cell>
                                        <Table.Cell  >End Date</Table.Cell>
                                    </Table.Row>                                    
                                <Table.Row>

                                <Table.Cell ><div style={calender}><PtDateInput disabled={this.state.disable} name="unpavedStartDate" placeholder="Start Date" 
                                value={this.state.unpavedStartDate==null ? '':this.state.unpavedStartDate}
                                onChange={(date) => { this.onChangeDate(date, "unpavedStartDate"); }} /></div></Table.Cell>
                                <Table.Cell ><PtDateInput disabled={this.state.disable}  name="unpavedEndDate" placeholder="End Date" 
                                value={this.state.unpavedEndDate==null ? '':this.state.unpavedEndDate}
                                    onChange={(date) => { this.onChangeDate(date, "unpavedEndDate"); }} /></Table.Cell>
                            </Table.Row>

                                </Table.Body>
                                </Table>
                    </Tab.Pane>
            },
            {
                menuItem: 'Zone Declaration', render: () =>
                
                    <Tab.Pane>

                        <button style={addzone} disabled={this.state.disable}
                            type="button"
                            onClick={this.handleAddZoneInput}
                            className="small"
                        > Add Zone </button>

                        {this.zoneTextBox()}
                       {/*{this.state.zonedesc.map((zone,idx)=>(
                            <div className="zoneInput">
                                <PtInputConditionTab style = {{width:'80%'}} disabled={this.state.disable} placeholder={`Zone Description`}
                                value={zone.zoneName} onChange={this.handleZoneNameChange(idx)}/>
                               
                            </div>
                       ))}*/}
                       
                       
                        {this.renderZoneList()}
                       
                            
                    </Tab.Pane>
            }            
        ];
    }


    handleAddZoneInput = () => {
        
        this.setState({
          zonedesc: this.state.zonedesc.concat([{ zoneName: "" }]),
        });
        console.log(this.state.zonedesc)
        this.zoneTextBox();
    }

    zoneTextBox = () => {
        return this.state.zonedesc.map((zone,idx)=>(
            <div className="zoneInput">
                <PtInputConditionTab style = {{width:'80%'}} disabled={this.state.disable} placeholder={`Zone Description`}
                value={zone.zoneName} onChange={this.handleZoneNameChange(idx)}/>               
            </div>
        ));
    }

    renderZoneList() {
        const zonedecField={
            width:'100%',
            marginTop: '10px'
        }
        return this.state.countyZones.map((x,i) =>        
        (
        <div key={x.key}>            
            <input style={zonedecField}
                key={x.key}
                data-index={i}
                name={`${x.key}`}
                type="text"
                className="ZoneFiled"
                value={this.state.countyZones[i]["label"]}
                onChange={this.handleInputChange}
                disabled={this.state.disable}
            />
        </div>
        ));
      }
      

    handleInputChange=(e)=>{
        const stateCountyZoneCopy = this.state.countyZones.slice();
        const objectCopy = Object.assign({},stateCountyZoneCopy[e.target.dataset.index]);
        objectCopy["label"] = e.target.value;
        objectCopy["value"] = e.target.value;
        stateCountyZoneCopy[e.target.dataset.index] = objectCopy
         
        this.setState({countyZones: stateCountyZoneCopy})    
    }

    // The below function fetches the values belonging to the county excluding the constant options
    getcountyZones (){
        const zoneOptions = []
        const keys = []
        fetch(`${config.server}/getcountyZones/`+this.props.agencyId)
        .then(response=>
            {
                return response.json();
            })
            
        .then(data=>{
           
            for (var i =0;i<data[0].length;i++){
                zoneOptions.push(data[0][i]['description'])
                keys.push(data[0][i]['Zone_key'])
            }
           let dropOptions = zoneOptions.map((option,idx)=>{
               return {key:keys[idx],value: option, label:option}
           });
           this.setState({
            countyZones:dropOptions
           });  
        })
        
        .catch(error=>{
            console.log(error);
        });

    }
    
    // The below function fetches the values belonging to the county including the constant options
    getDropdownZoneOptions () {
        const zoneOptions = []
        const keys = []
        fetch(`${config.server}/getzoneOptions/`+this.props.agencyId)
        .then(response=>
            {
                return response.json();
            })
            
        .then(data=>{
            for (var i =0;i<data[0].length;i++){
                zoneOptions.push(data[0][i]['description'])
                keys.push(data[0][i]['Zone_key'])
            }
           let dropOptions = zoneOptions.map((option,idx)=>{
               return {key:keys[idx],value: keys[idx], label:option}
           });
          
           this.setState({
               options:dropOptions,
               selectedZone:dropOptions[0]['value']
            
           });         
        })
        .catch(error=>{
            console.log(error);
        });
    
    }

    onChangeDropdown = (e)=>{
        const {name,value} = e.target
        this.setState({
            [name]:value},
            () => {
                this.fetchpavedDate();
                this.fetchunpavedDate();
            });
    }

    handleZoneNameChange = idx => evt => {
        const newZone = this.state.zonedesc.map((zone, sidx) => {
            if (idx !== sidx) return zone;
            return { ...zone, zoneName: evt.target.value };
        });
    
        this.setState({ zonedesc: newZone });
    };

    editClick = ()=>{
       this.setState({
            disable: !this.state.disable,
            edit: !this.state.edit,
            editBtnDisable: !this.state.editBtnDisable
        });
    }

    cancelClick = () =>{  
           
            this.setState({
                disable: !this.state.disable,
                edit: !this.state.edit,
                editBtnDisable: !this.state.editBtnDisable,
                zonedesc: []
            });
    }


    render() {
        const btnClass = {
            marginTop:'5px'
        }

        return(
        <div> 
             <Grid.Row>
                    <h5>Load Restriction Date Manager</h5>
                </Grid.Row>
                <Divider />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.state.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>
                {this.state.edit && <Button style={btnClass} size='tiny' onClick={this.clickSave} color='green'>Save</Button>}
                
                {this.props.loggedin && <Button style={btnClass} disabled={this.state.editBtnDisable} size='tiny' onClick={this.editClick} color={this.state.edit ? 'yellow' : 'green'}>Edit</Button>}
                {this.state.edit && <Button style={btnClass} size='tiny' onClick={this.cancelClick}>Cancel</Button>}

            </div>
      );
    }

    onTabChange = (e, data) => {
        this.updateActiveIndex(data.activeIndex);
    }

    updateActiveIndex = (activeIndex) => {
        this.setState({ activeIndex: activeIndex });
    }

    clickSave = () =>{
        if(this.state.countyZones.length===0 && this.state.zonedesc.length===1 && this.state.selectedZone!==1000 && this.state.selectedZone!==999){
            alert("Please Add atleast 2 zones")
        }
        else{
            this.props.handleLoadingOpen(true)
            let tmpArr = []
            for(let i=0;i<this.state.countyZones.length;i++){
                tmpArr.push(this.state.countyZones[i]['value'])
            }
            for(let i=0;i<this.state.zonedesc.length;i++){
                if(this.state.zonedesc[i]['zoneName'] !== "null" || this.state.zonedesc[i]['zoneName'] !== undefined)
                    tmpArr.push(this.state.zonedesc[i]['zoneName'])
            }
            const arrFiltered = tmpArr.filter(el => {
                return el != null && el !== '';
              });
            let finalData = {                
                zonedesc: arrFiltered,
                agencyId: this.props.agencyId,
                // eslint-disable-next-line
                selectedZone: parseInt(this.state.selectedZone),
                pavedStartDate: this.state.pavedStartDate,
                pavedEndDate: this.state.pavedEndDate,
                unpavedStartDate:this.state.unpavedStartDate,
                unpavedEndDate: this.state.unpavedEndDate
            };
            console.log('Final Data ',finalData)
            
         $.ajax({
                type: 'POST',
                url: `${config.server}\\createzonedeclarationManager`,
                contentType: 'application/json',
                data: JSON.stringify(finalData),

                success: (data) => {
                    console.log('Success data ',data)
                    this.props.handleLoadingOpen(false);
                    this.cancelClick();
                    this.getcountyZones();
                },
            });
            
        }
    }

    fetchpavedDate = () =>{
        
        fetch(`${config.server}/getPavedDates/`+this.props.agencyId+'/'+this.state.selectedZone)
        .then(response=>
            {
                return response.json();
            })            
        .then(data=>{
               console.log("Onclick Data called ",data)
            if(data[0].length===0){
                this.setState({pavedStartDate:null, pavedEndDate:null})
            }
            else if(data[0][0]['DateManStartDate']===null && data[0][0]['DateManEndDate']===null) {
                this.setState({pavedStartDate:null, pavedEndDate:null})
            }
           else{
            this.setState({
                pavedStartDate: data[0][0]['DateManStartDate'].slice(0,10),
                pavedEndDate: data[0][0]['DateManEndDate'].slice(0,10)
            })
           }
        })
    }


    fetchunpavedDate = () =>{       
        fetch(`${config.server}/getunPavedDates/`+this.props.agencyId+'/'+this.state.selectedZone)
        .then(response=>
            {
                return response.json();
            })            
        .then(data=>{           
            if(data[0].length===0){
                this.setState({unpavedStartDate:null, unpavedEndDate:null})
            }
            else if(data[0][0]['DateManStartDate']===null && data[0][0]['DateManEndDate']===null) {
                this.setState({unpavedStartDate:null, unpavedEndDate:null})
            }
            else{
                this.setState({
                    unpavedStartDate: data[0][0]['DateManStartDate'].slice(0,10),
                    unpavedEndDate: data[0][0]['DateManEndDate'].slice(0,10)
                })
            }
        })  
    }

    



    zoneDescriptionInputChange = (i,event) =>{
        let values = [...this.state.zonedesc];
        values[i] = event.target.value;
        this.setState({ zonedesc:values });
    }

    
    onChangeDate = (date, name) => {
        
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ [name]: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
        }
        else {
            this.setState({ [name]: null });
        }
    }

    componentDidMount (){
        this.getDropdownZoneOptions(); 
        this.getcountyZones();   
        this.fetchpavedDate();
        this.fetchunpavedDate();

    }
}



// WEBPACK FOOTER //
// ./src/layers/datemanager.js